import { useContext, useEffect, useState } from "react";
import PageContext from "@/utils/page-context";

export default function useMobileView() {

    const pageContext = useContext(PageContext);
    const [mobileView, setMobileView] = useState((pageContext as any).mobileView);

    useEffect(() => {
        setMobileView((pageContext as any).mobileView);
    }, [(pageContext as any).mobileView]);

    return [mobileView];
};